export default __webpack_public_path__ + "static/article-kris-kringle-gifting-b183ad8d9ec7d4922fc155d804c5c16a.jpg";